import { HttpClient } from '@angular/common/http';
import { JWTActionRequest, JWTActionResponse } from '../../../../node/transaction/dist';
import { AppConfig } from '../app.config';
import { isValidExpiry, parseJWT } from './jwt-util';
import { UserCredentials } from './user-credentials';

export class UserCredentialsLDAP implements UserCredentials {
    private username: string;
    private idToken: string;
    private accessToken: string;
    private refreshToken: string;

    constructor(private appConfig: AppConfig, private http: HttpClient) {
        const idToken = window.sessionStorage.getItem('Liquitics.IdToken');
        if (idToken) {
            const payload = parseJWT(idToken);
            this.idToken = idToken;
            this.username = payload.email;

        }
        const accessToken = window.sessionStorage.getItem('Liquitics.AccessToken');
        if (accessToken) {
            this.accessToken = accessToken;
        }

        const refreshToken = window.sessionStorage.getItem('Liquitics.RefreshToken');
        if (refreshToken) {
            this.refreshToken = refreshToken;
        }
    }

    handleJWTTokens(idToken: string, accessToken: string, refreshToken: string): void {
        this.idToken = idToken;
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
        if (idToken) {
            const payload = parseJWT(idToken);
            this.username = payload.email;
        }
        window.sessionStorage.setItem('Liquitics.IdToken', idToken);
        window.sessionStorage.setItem('Liquitics.AccessToken', accessToken);
        window.sessionStorage.setItem('Liquitics.RefreshToken', refreshToken);
    }

    getUserName(): string {
        return this.username;
    }

    async refreshTokens(): Promise<void> {
        const options = { headers: {} };
        const apiUrlToUse = this.appConfig.getAPIUrlToUse();
        const url = apiUrlToUse + 'auth/jwt';
        const result: JWTActionResponse = await new Promise((resolve, reject) => {
            this.http.post<any>(url, {
                type: 'REFRESH',
                refreshToken: this.refreshToken,
                idToken: this.idToken,
                accessToken: this.accessToken,
            } as JWTActionRequest, options)
                .subscribe(
                    {
                        next: (response) => {
                            resolve(response);
                        },
                        error: (error) => {
                            reject(error);
                        },
                        complete: () => {
                            resolve(undefined);
                        }
                    });
        });
        this.idToken = result.idToken;
        this.accessToken = result.accessToken;
    }

    async getIdToken(): Promise<string> {
        if (this.idToken) {
            const payload = parseJWT(this.idToken);
            if (!isValidExpiry(payload)) {
                // Try to refresh the token
                await this.refreshTokens();
            }
        }
        return this.idToken;
    }

    async getAccessToken(): Promise<string> {
        if (this.accessToken) {
            const payload = parseJWT(this.accessToken);
            if (!isValidExpiry(payload)) {
                // Try to refresh the token
                await this.refreshTokens();
            }
        } else {
            await this.refreshTokens();
        }
        return this.accessToken;
    }

    async getRefreshToken(): Promise<string> {
        return this.refreshToken;
    }

    async handleGlobalLogout(): Promise<string> {
        this.idToken = undefined;
        this.accessToken = undefined;
        this.refreshToken = undefined;
        window.sessionStorage.removeItem('Liquitics.IdToken');
        window.sessionStorage.removeItem('Liquitics.AccessToken');
        window.sessionStorage.removeItem('Liquitics.RefreshToken');

        return 'Not implemented';
    }

    async isAuthenticated(): Promise<boolean> {
        const accessToken = await this.getAccessToken();
        if (!accessToken) {
            return Promise.resolve(false);
        }
        const payload = parseJWT(accessToken);
        return Promise.resolve(isValidExpiry(payload));
    }
}